/* FENN: faixa de categorias que recolhe suave ao rolar (padrão do skill cabecalho-suave, igual ao
 * layout offline). Calcula um "progresso" de 0 a 1 conforme a pessoa rola pra baixo (160px de
 * rolagem = 100% recolhida) ou pra cima, com suavização por tempo, e a faixa desliza pra baixo do
 * cabeçalho na proporção.
 *
 * Versão 4 (10/09/2026). Histórico do que NÃO funcionou na loja (página pesada):
 *  - v1: variável CSS na raiz a cada quadro (recalcula a página inteira): engasgava;
 *  - v2: transform direto + suavização por tempo: ficou suave, mas sobrava uma tira branca entre a
 *    faixa e o herói, porque o espaço da faixa continuava reservado;
 *  - v3: encolher a altura do espaço a cada quadro: sem tira branca, mas isso obriga o navegador a
 *    reorganizar a página inteira a cada quadro (layout), e numa rolagem rápida "embola".
 *  Esta versão só mexe em transform (o navegador anima no compositor, sem layout): a faixa desliza
 *  pra baixo do cabeçalho, e o herói da página inicial já fica posicionado POR BAIXO do espaço da
 *  faixa (margem negativa no CSS, ver sections/fenn-faixa-categorias.liquid). Assim, o pedaço que a
 *  faixa desocupa mostra o vídeo do herói, e a borda de cima do herói acompanha a borda de baixo da
 *  faixa. Ela só começa a recolher depois que o cabeçalho gruda no topo.
 */
(function () {
  var faixa = document.querySelector('.fenn-faixa-cats');
  if (!faixa) return;
  var secao = faixa.closest('.shopify-section') || faixa.parentElement;
  var topo = document.getElementById('header-component');
  var raiz = document.documentElement;

  var alturaFaixa = 0, yGruda = 0;
  // v5 (11/09/2026): quem rola é o .page-wrapper (rolagem interna, ver fenn-rolagem.css), não a janela
  function rolador() { return (window.fennRolador && window.fennRolador()) || document.querySelector('.page-wrapper') || raiz; }
  function scrollReal() {
    var r = rolador();
    var maximo = Math.max(0, r.scrollHeight - r.clientHeight);
    return Math.min(maximo, Math.max(0, r.scrollTop || 0));
  }
  // v6 (11/09/2026): o cabeçalho fica parado no topo desde o início; a barra de avisos rola por baixo dele. A faixa
  // gruda no cabeçalho quando a barra terminou de sair (yGruda = altura da barra), e só então começa a recolher.
  var barra = document.querySelector('#header-group .shopify-section:has(.header-marquee)');
  function medir() {
    if (topo) {
      var r = topo.getBoundingClientRect();
      if (r.height > 0) secao.style.top = (Math.round(r.height) - 1) + 'px';
    }
    yGruda = barra ? barra.offsetHeight : 0;
    var h = faixa.offsetHeight;
    if (h > 0 && h !== alturaFaixa) {
      alturaFaixa = h;
      raiz.style.setProperty('--fenn-faixa-altura', h + 'px'); // só quando muda (carga, rotação), nunca por quadro
    }
  }

  var CURSO = 160;   // px de rolagem pra recolher por completo
  var TAU = 80;      // ms de suavização (equivale a 18% por quadro a 60 quadros/s)
  var alvo = 0, atual = 0, animando = false, ultimoT = 0;

  function aplicar() {
    faixa.style.transform = 'translate3d(0, ' + (-atual * alturaFaixa).toFixed(1) + 'px, 0)';
  }
  function animar(t) {
    var dt = ultimoT ? Math.min(50, t - ultimoT) : 16;
    ultimoT = t;
    var falta = alvo - atual;
    if (Math.abs(falta) < 0.002) { atual = alvo; aplicar(); animando = false; ultimoT = 0; return; }
    atual += falta * (1 - Math.exp(-dt / TAU));
    aplicar();
    requestAnimationFrame(animar);
  }

  medir();
  window.addEventListener('resize', medir);
  window.addEventListener('load', medir);
  setTimeout(medir, 500);

  var ultimoY = scrollReal();
  rolador().addEventListener('scroll', function () {
    var y = scrollReal(), dif = y - ultimoY; ultimoY = y;
    alvo = Math.min(1, Math.max(0, alvo + dif / CURSO));
    // nunca recolhe antes de o cabeçalho grudar, e nunca mais do que a rolagem além desse ponto permite
    alvo = Math.min(alvo, Math.max(0, (y - yGruda) / CURSO));
    if (!animando) { animando = true; ultimoT = 0; requestAnimationFrame(animar); }
  }, { passive: true });
})();
